app.service('changeNick', function (modal, validate) {
	var $self, $nick, $nickStatus, $nickForm;

	function sendSuccess(status) {
		$nickStatus.removeClass('error valid');
		$nickStatus.addClass(status.toLowerCase());
		$nick.removeClass('error valid');
		$nick.addClass(status.toLowerCase());

		switch (status) {
			case 'VALID':
				$nickStatus.text('Nick poprawnie zmieniony');
				break;
			case 'ERROR':
				$nickStatus.text('Nick jest już zajęty lub niepoprawny');
				break;
		}
		$self.removeClass('loading');
	}
	function sendError() {
		$self.removeClass('loading');
		modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później');
	}

	function send(options, callback) {
		$self.addClass('loading');
		var data = $.extend({
			nick: $nick.val(),
		}, options);

		$.ajax({
			url: '/frontUser-unique-nick.ltr',
			type: 'POST',
			data: data,
			success: function (html) {
				var status = $.trim(html);
				sendSuccess(status);
				if (callback) {
					callback(status, data.ACTION === 'CHECK_SAVE');
				}
			},
			error: function () {
				sendError();
			}
		});
	}

	function check(options, callback) {
		send(
			$.extend({
				ACTION: 'CHECK',
			}, options),
			callback
		);
	}

	function save(options, callback) {
		send(
			$.extend({
				ACTION: 'CHECK_SAVE'
			}, options),
			callback
		);
	}

	function setElements() {
		$self = $('#change-nick');
		$nick = $('#nick', $self);
		$nickStatus = $('#nick-status', $self);
		$nickForm = $('#nickView-form', $self);
	}
	function setEvents(options, callback) {
		validate.task('editNick', {form: $nickForm});
		$('.js-check-nick', $self).click(function () {
			check(options, callback);
		});
		$('.js-nick-save', $self).click(function () {
			if($nickForm.valid()) {
				save(options, callback);
			};
			return false;
		});
	}
	function init(options, callback) {
		setElements();
		setEvents(options, callback);
	}

	return {
		init: init,
		check: check
	};
});